import { ComponentProps, FC, PropsWithChildren } from 'react'
import { useNumberInput } from './hooks'
import { NumberInputContext } from './NumberInputContext'
import { NumberInputPrimitive } from './primitives'
import { NumberInputProps } from './types'

export const NumberInput: FC<
  PropsWithChildren<
    NumberInputProps & Omit<ComponentProps<typeof NumberInputPrimitive.Root>, 'onChange'>
  >
> = ({
  step = 1,
  defaultValue = 0,
  round,
  variant = 'default',
  precision = 0,
  min = -Infinity,
  max = Infinity,
  isDisabled,
  onChange,
  formattingOptions,
  children,
  ...rest
}) => {
  const state = useNumberInput({
    step,
    defaultValue,
    precision,
    min,
    max,
    onChange,
    formattingOptions
  })

  return (
    <NumberInputContext.Provider
      value={{
        ...state,
        round,
        variant,
        isDisabled
      }}
    >
      <NumberInputPrimitive.Root {...rest}>{children}</NumberInputPrimitive.Root>
    </NumberInputContext.Provider>
  )
}
